import React, { useEffect } from 'react';

// ═══ MOBILE-RESPONSIVE DESIGN ════════════════════════════════════════════
const ResponsiveStyles = () => {
  useEffect(() => {
    const id = 'sykes-responsive-css';
    if (document.getElementById(id)) return;
    const style = document.createElement('style');
    style.id = id;
    style.textContent = `
      @media (max-width: 768px) {
        .sykes-page { flex-direction: column !important; }
        .sykes-sidebar { width: 100% !important; height: auto !important; position: relative !important; flex-direction: row !important; overflow-x: auto !important; padding: 8px 0 !important; }
        .sykes-sidebar > div:first-child { display: none !important; }
        .sykes-sidebar button { padding: 6px 12px !important; font-size: 11px !important; white-space: nowrap !important; }
        .sykes-main { padding: 12px !important; max-width: 100% !important; }
        .sykes-grid-3 { grid-template-columns: 1fr !important; }
        .sykes-grid-2 { grid-template-columns: 1fr !important; }
        table { font-size: 11px !important; }
        th, td { padding: 4px 6px !important; }
        .sykes-modal-content { width: 95% !important; max-width: 95% !important; padding: 16px !important; }
        .sykes-hide-mobile { display: none !important; }
        input, select, textarea { font-size: 16px !important; }
      }
      @media (max-width: 1024px) and (min-width: 769px) {
        .sykes-sidebar { width: 180px !important; }
        .sykes-main { padding: 16px !important; }
        .sykes-grid-3 { grid-template-columns: repeat(2, 1fr) !important; }
      }
      @media print {
        .sykes-sidebar, .sykes-topbar, .sykes-no-print { display: none !important; }
        .sykes-main { padding: 0 !important; max-width: 100% !important; }
        .sykes-page { display: block !important; }
      }
    `;
    document.head.appendChild(style);
    // Viewport meta tag for mobile
    if (!document.querySelector('meta[name=viewport]')) {
      const meta = document.createElement('meta');
      meta.name = 'viewport';
      meta.content = 'width=device-width, initial-scale=1, maximum-scale=1';
      document.head.appendChild(meta);
    }
    return () => { const el = document.getElementById(id); if(el) el.remove(); };
  }, []);
  return null;
};

const EditableRow = React.memo(function EditableRow({ item, columns, onUpdate, rowStyle }) {
  return (
    <tr style={rowStyle}>
      {columns.map(col => (
        <td key={col.key} style={col.tdStyle}>
          {col.render ? col.render(item, (field, value) => onUpdate(field, value)) :
            <input value={item[col.key] || ''} onChange={e => onUpdate(col.key, e.target.value)}
              type={col.type || 'text'} style={col.inputStyle} placeholder={col.placeholder} />}
        </td>
      ))}
    </tr>
  );
});


export { ResponsiveStyles };
